module.exports = __webpack_public_path__ + "img/not-authorized.7f2e55c8.svg";